
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"45","height":"45","rx":"22.5","fill":"#1E88E5"}}),_c('path',{attrs:{"d":"M27.75 22.5A5.228 5.228 0 0133 27.75a5.204 5.204 0 01-.805 2.8l3.593 3.617-1.621 1.621-3.64-3.581A5.247 5.247 0 0127.75 33a5.228 5.228 0 01-5.25-5.25 5.228 5.228 0 015.25-5.25zm0 2.333a2.916 2.916 0 100 5.833 2.916 2.916 0 000-5.833zm2.917-7H12V29.5h8.365c.198.84.537 1.622.968 2.333H12A2.333 2.333 0 019.667 29.5v-14A2.325 2.325 0 0112 13.167h7l2.333 2.333h9.334A2.333 2.333 0 0133 17.833v4.445a7.626 7.626 0 00-2.333-1.528v-2.917z","fill":"#fff"}})])
          )
        }
      }
    